export { default as SellerPageQuery } from './SellerPageQuery';